import React from 'react';
import BusinessInNumbersCard from './BusinessInNumbersCard';

const BusinessInNumbersSlider = ({ color }) => {
  const data = [
    { title: '2006', description: 'experienced in digital marketing since 2006' },
    { title: '$180 mln', description: 'in revenue for our clients' },
    { title: '98%', description: 'positive reviews from our costumers' },
    { title: '91%', description: 'returning customers' },
    { title: '81%', description: '33 staff members, 81% of them are female:' },
    { title: '13', description: 'Partnerships in 13 countries' },
    { title: '2006', description: 'experienced in digital marketing since 2006' },
    { title: '$180 mln', description: 'in revenue for our clients' },
    { title: '98%', description: 'positive reviews from our costumers' },
    { title: '91%', description: 'returning customers' },
    { title: '81%', description: '33 staff members, 81% of them are female:' },
    { title: '13', description: 'Partnerships in 13 countries' },
    { title: '2006', description: 'experienced in digital marketing since 2006' },
    { title: '$180 mln', description: 'in revenue for our clients' },
    { title: '98%', description: 'positive reviews from our costumers' },
    { title: '91%', description: 'returning customers' },
    { title: '81%', description: '33 staff members, 81% of them are female:' },
    { title: '13', description: 'Partnerships in 13 countries' },
  ];

  return (
    <div className={'trick-line'}>
      <div className={' ticker-line-container z-10 py-[10px]'}>
        <div className="ticker-line">
          {data.map(({ title, description }, idx) => {
            return (
              <div key={idx} className="block pr-[15px] mt-[5px] ml-[5px] leading-[20px]">
                <BusinessInNumbersCard title={title} description={description} color={color} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BusinessInNumbersSlider;
